define('models/pages/account-main',['require','underscore','chaplin','models/base/model','models/base/collection','lib/utils'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Chaplin = require('chaplin'),
        Model = require('models/base/model'),
        Collection = require('models/base/collection'),
        utils = require('lib/utils');

    var AccountMainItem = Model.extend({
    });

    var AccountMainItemCollection = Collection.extend({
        model: AccountMainItem,
        initialize: function() {
            Collection.prototype.initialize.apply(this, arguments);
            _.extend(this, Chaplin.SyncMachine);
        }
    });

    var AccountMainPageModel = Model.extend({
        urlPath: '/page/account/main',
        defaults: {
            incomeDebit: 0,
            incomeCredit: 0,
            turnoverDebit: 0,
            turnoverCredit: 0,
            currency: 'USD'
        },
        constructor: function(data) {
            Model.apply(this, arguments);

            this.items = new AccountMainItemCollection(data ? data.items : [], { parse: true });

            this.on('beforeLoad', function() {
                this.items.beginSync();
            });

            this.on('afterLoad', function() {
                this.items.finishSync();
            });
        },
        parse: function(data) {
            for (var i=0, l=data.items.length; i<l; i++) {
                data.items[i].selected = false;
            }
            this.items.reset(data.items, { silent: true });
            delete data.items;
            return data;
        },
        urlParams: function() {
            var params = Model.prototype.urlParams.apply(this, arguments);

            params.fromDate = utils.fmtDate(this.get('fromDate'));
            params.toDate = utils.fmtDate(this.get('toDate'));
            return params;
        }
    });

    return AccountMainPageModel;
});
